import * as apiTo from './api'
import { baseChartMixin } from '@/reusable/base-chart/base-chart-mixin'

export function commonPropertiesMixin(api, customChartData) {
  return {
    mixins: [baseChartMixin],

    props: {
      periodId: [Number, String]
    },

    created() {
      this.getChartData()
      this.customChartData = customChartData
    },

    methods: {
      getChartData() {
        apiTo.getChartData(api, this.periodId).then(({ data }) => {
          this.chartData = data.result.chart
          this.supportData = data.result.support_data
        })
      }
    }
  }
}
